<script setup>
    const props = defineProps({
        imgUrl: String
    });
</script>
<template>
    <div
        class="dropdown-img-start"
        :style="imgUrl ? `background-image: url(${imgUrl});` : ''"
        role="img"
        aria-label="Link">
        <slot />
    </div>
</template>
<script>
    export default {
        name: 'NavDroppedImgSection'
    };
</script>
